export default __webpack_public_path__ + "static/monitor-9087265a513548a7ca554d9402876cd0.svg";